import { Helmet } from "react-helmet-async";
import { useBreadcrumb } from "../hooks/useBreadcrumbSchema";

const SEOcomponent = ({ metaTag }) => {
  const { getBreadcrumbs } = useBreadcrumb();

  const {
    canonical,
    noindex = false,
    title,
    description,
    ogTitle,
  } = metaTag || {};
  const siteUrl = process.env.REACT_APP_SITE_URL || window.location.origin;

  return (
    <Helmet
      prioritizeSeoTags={true}
      onChangeClientState={() => {
        const tags = document.querySelectorAll('meta[name="description"]');
        if (tags.length > 1) {
          tags[0].remove();
        }
      }}
    >
      <link rel="canonical" href={canonical} />
      <meta
        name="robots"
        content={noindex ? "noindex, nofollow" : "index, follow"}
      ></meta>
      <title>{title}</title>
      <meta name="description" content={description} />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content="website" />
      <meta property="og:url" content={canonical} />
      <meta property="og:title" content={ogTitle || title} />
      <meta property="og:description" content={description} />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={ogTitle || title} />
      <meta name="twitter:description" content={description} />

      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org/",
          "@type": "BreadcrumbList",
          itemListElement: getBreadcrumbs(),
        })}
      </script>

      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "WebPage",
          name: title,
          description: description,
          url: canonical,
          mainEntityOfPage: canonical,
          // datePublished: "2023-01-01",
          // dateModified: "2024-01-15",
          // lastReviewed: "2024-01-15",
          inLanguage: "en",
          // primaryImageOfPage: {
          //   "@type": "ImageObject",
          //   url: "https://www.nextcosmostechnology.com/images/og-image.jpg",
          //   width: 1200,
          //   height: 630,
          // },
        })}
      </script>
    </Helmet>
  );
};

export default SEOcomponent;
